import { render, staticRenderFns } from "./AtomSelect.vue?vue&type=template&id=5533acdf&"
import script from "./AtomSelect.vue?vue&type=script&lang=ts&"
export * from "./AtomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AtomSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
